<template>
  <div>
    <div >
      <button
          v-for="(item, index) in meta.buttons" :key="index"
          v-status="meta.permission_prefix + item.name"
          v-b-tooltip.hover.top="item.label"
              :class="classBtn + item.class" @click="action(data, item.name)">
        <i :class="iconClass + item.icon"></i>
      </button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    data:{},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    },
  },
  data() {
    return {
      classBtn: 'btn btn-sm m-1 ',
      iconClass: 'fa fa-',
    };
  },
}
</script>